// extracted by mini-css-extract-plugin
module.exports = {"inputSearchContainer":"input-search_inputSearchContainer__D1_Cv","icon":"input-search_icon__k4F_w","erase":"input-search_erase__Ze_He","label":"input-search_label__m1nLw"};